<script>
  import { onMount } from 'svelte';
  import { navigate } from 'svelte-routing';
  import Conexoes from '../Classes/Conexoes.js';
  import Constantes from '../Classes/Constantes.js';
  import LoadingTela from '../componentes_basicos/LoadingTela.svelte';

  let isLoading = true;
  let statusMensagem = 'Verificando o seu e-mail...';
  let sucesso = false;

  const conexao = new Conexoes();

  onMount(async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    
    if (!token) {
      isLoading = false;
      statusMensagem = "Token inválido ou ausente.";
      return;
    }

    const url = Constantes.api_acesso.replace('acesso.php', 'confirmar_email.php');
    const resposta = await conexao.conecta(url, { body: { token } });
    
    isLoading = false;
    sucesso = resposta?.sucesso || false;
    statusMensagem = resposta?.mensagem || "Ocorreu um erro ao verificar o token.";
  });
</script>

<svelte:head>
  <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700;800&display=swap" rel="stylesheet">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css">
</svelte:head>

<LoadingTela {isLoading} />

<div class="login-wrapper">
  <div class="brand-area fade-in">
    <div class="logo-placeholder"><i class="fas fa-leaf"></i></div>
    <h1>Sistema de Agendamentos</h1>
  </div>

  <div class="login-card fade-in" style="text-align: center;">
    
    {#if isLoading}
      <h3>Aguarde...</h3>
    {:else if sucesso}
      <i class="fas fa-check-circle" style="font-size: 4rem; color: #4a6c56; margin-bottom: 20px;"></i>
      <h3>Tudo Pronto!</h3>
    {:else}
      <i class="fas fa-exclamation-triangle" style="font-size: 4rem; color: #cfaa6c; margin-bottom: 20px;"></i>
      <h3>Aviso</h3>
    {/if}

    <p class="subtitle" style="font-size: 1.1rem; margin-top: 15px;">{statusMensagem}</p>

    {#if !isLoading}
      <button class="btn-primary w-100 mt-3" on:click={() => navigate(Constantes.tela_login)}>
        Ir para o Login <i class="fas fa-arrow-right ms-2"></i>
      </button>
    {/if}
  </div>
</div>

<style>
  /* Mesmo CSS minimalista de autenticação */
  :root { --primary: #4a6c56; --primary-dark: #3a5443; --accent: #cfaa6c; --text-main: #2c3e34; --text-muted: #738a7c; --border: #e0e6e2; }
  * { box-sizing: border-box; }
  .login-wrapper { min-height: 100vh; display: flex; flex-direction: column; align-items: center; justify-content: center; background: linear-gradient(135deg, var(--primary) 0%, #2c3e34 100%); font-family: 'Montserrat', sans-serif; padding: 20px; }
  .brand-area { text-align: center; color: white; margin-bottom: 30px; }
  .logo-placeholder { width: 60px; height: 60px; background: var(--accent); color: white; border-radius: 16px; display: flex; align-items: center; justify-content: center; font-size: 1.8rem; margin: 0 auto 15px auto; box-shadow: 0 4px 15px rgba(207, 170, 108, 0.4); transform: rotate(10deg); }
  .brand-area h1 { margin: 0; font-size: 1.5rem; font-weight: 800; }
  .login-card { background: #fff; padding: 40px 35px; border-radius: 16px; width: 100%; max-width: 420px; box-shadow: 0 15px 50px rgba(0,0,0,0.3); border-bottom: 5px solid var(--accent); }
  .login-card h3 { margin: 0; color: var(--primary); font-size: 1.6rem; font-weight: 800; }
  .subtitle { color: var(--text-muted); margin-bottom: 20px; }
  .w-100 { width: 100%; } .ms-2 { margin-left: 8px; } .mt-3 { margin-top: 15px; }
  .btn-primary { background: var(--primary); color: white; border: none; padding: 15px; border-radius: 8px; font-weight: 700; font-size: 1.05rem; cursor: pointer; transition: background 0.3s, transform 0.2s; margin-top: 10px; }
  .btn-primary:hover { background: var(--primary-dark); transform: translateY(-2px); }
  .fade-in { animation: fadeIn 0.4s ease-in-out; }
  @keyframes fadeIn { from { opacity: 0; transform: translateY(15px); } to { opacity: 1; transform: translateY(0); } }

  @media (max-width: 768px) {
    .login-wrapper {
      justify-content: flex-start;
      padding: 32px 16px;
    }

    .brand-area {
      margin-bottom: 20px;
    }

    .login-card {
      padding: 28px 20px;
      border-radius: 14px;
    }
  }
</style>